export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13'),
	() => import('./nodes/14'),
	() => import('./nodes/15'),
	() => import('./nodes/16'),
	() => import('./nodes/17'),
	() => import('./nodes/18'),
	() => import('./nodes/19'),
	() => import('./nodes/20'),
	() => import('./nodes/21'),
	() => import('./nodes/22'),
	() => import('./nodes/23'),
	() => import('./nodes/24'),
	() => import('./nodes/25'),
	() => import('./nodes/26')
];

export const server_loads = [];

export const dictionary = {
		"/": [9],
		"/auth/social/callback": [10,[2]],
		"/[lang]": [~11,[3]],
		"/[lang]/activation": [12,[3]],
		"/[lang]/alternatives": [13,[3]],
		"/[lang]/booking-confirmation": [14,[3]],
		"/[lang]/booking-summary": [15,[3]],
		"/[lang]/car/[userId]/[carId]": [16,[3,4]],
		"/[lang]/car/[userId]/[carId]/gallery": [17,[3,4]],
		"/[lang]/cookie-policy": [18,[3,5]],
		"/[lang]/driver": [19,[3,6]],
		"/[lang]/forgot-password": [20,[3]],
		"/[lang]/login": [21,[3]],
		"/[lang]/owner": [22,[3,7]],
		"/[lang]/privacy-policy": [23,[3,8]],
		"/[lang]/protection": [24,[3]],
		"/[lang]/register": [25,[3]],
		"/[lang]/search": [26,[3]]
	};

export const hooks = {
	handleError: (({ error }) => { console.error(error) }),
	
	reroute: (() => {}),
	transport: {}
};

export const decoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.decode]));

export const hash = false;

export const decode = (type, value) => decoders[type](value);

export { default as root } from '../root.js';